import {
  BASE_PATH_2_QUERY,
  BASE_PATH_3_QUERY,
  RESUME_ID_QUERY,
} from '@glass/common/modules/pages/queryParams';

import { COMPLETE_BUILDER_STEP } from '@glass/shared/modules/resumes/resumesReducer';

const completeBuilderStepAction = ({
  [RESUME_ID_QUERY]: resumeId,
  [BASE_PATH_2_QUERY]: section,
  [BASE_PATH_3_QUERY]: step,
}) => ({
  type: COMPLETE_BUILDER_STEP,
  payload: {
    [RESUME_ID_QUERY]: resumeId,
    [BASE_PATH_2_QUERY]: section,
    [BASE_PATH_3_QUERY]: step,
  },
});

export default completeBuilderStepAction;
